var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.crumbs),function(crumb){return _c('li',[_c('router-link',{attrs:{"to":_vm.buildLink(crumb)}},[_vm._v(_vm._s(_vm.localize(crumb)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb5b4a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/RouterBreadcrumb.vue
// module id = 368
// module chunks = 1